import React, { useCallback, useState } from 'react'
import PropTypes from 'prop-types'

import { Text } from 'Components/UI/_Legacy'

import { Container, Header, PlusIcon, StyledCollapse } from './styles'

function AQ({ aq }) {
  const [isOpen, setIsOpen] = useState(false)

  const handleToggleOpen = useCallback(() => setIsOpen(!isOpen), [isOpen])

  return (
    <Container className={`${isOpen && 'opened'}`}>
      <Header onClick={handleToggleOpen}>
        <PlusIcon opened={isOpen ? 1 : 0} />

        <Text as="h3" letterSpacing={0.5} light ml={5}>
          {aq?.question}
        </Text>
      </Header>

      <StyledCollapse isOpen={isOpen} px={[7, 7, 11]}>
        <Text
          letterSpacing={0.5}
          light
          lineHeight={1.71}
          markdown
          mt={4}
          small
          textAlign="justify"
        >
          {aq?.answer}
        </Text>
      </StyledCollapse>
    </Container>
  )
}

AQ.defaultProps = {
  aq: {},
}

AQ.propTypes = {
  aq: PropTypes.object,
}

export default AQ
